module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-ExtraBoldItalic.503c08f.woff";